import React from 'react';
import { View } from 'react-native';
import MyAccountLine from '../../../MyAccountLine';

//= ========================================================================

const ScrollViewWithContactLines = ({
  globJSON,
  simPlatform,
  transactionsList,
}) => {
  const { colors } = globJSON.configurations.theme;

  return (
    <View style={{
      flexDirection: 'column',
      backgroundColor: colors.app_background_color,
    }}
    >
      {transactionsList.map((transaction) => (
        <View>
          <MyAccountLine
            simPlatform={simPlatform}
            globJSON={globJSON}
            txtAmount={transaction.txtAmount}
            txtPrimary={transaction.txtPrimary}
            txtSecondary={transaction.txtSecondary}
            isPositive={transaction.isPositive}
            isPending={transaction.isPending}
            isDate={transaction.isDate}
          />
        </View>
      ))}
    </View>

  );
};
export default ScrollViewWithContactLines;
